export default __webpack_public_path__ + "static/media/koko.9f63bf27.jpeg";